import { z } from "zod";
import { FailureSchema, IsoDateTimeSchema, ProgressSchema } from "./common";
import { BookIdSchema, ChapterIdSchema, JobIdSchema } from "./ids";
import { JobKindSchema, JobStatusSchema } from "./states";

/**
 * One job row as the progress views read it. `runAfter` after a failure is
 * the retry time; `manualRetryRequired` means the automatic retries are used
 * up and POST /jobs/:id/retry is the only way on.
 */
export const JobSummarySchema = z.strictObject({
  id: JobIdSchema,
  kind: JobKindSchema,
  status: JobStatusSchema,
  bookId: BookIdSchema.nullable(),
  chapterId: ChapterIdSchema.nullable(),
  progress: ProgressSchema.nullable(),
  attempts: z.int().nonnegative(),
  maxAttempts: z.int().positive(),
  runAfter: IsoDateTimeSchema.nullable(),
  manualRetryRequired: z.boolean(),
  failure: FailureSchema.nullable(),
  startedAt: IsoDateTimeSchema.nullable(),
  finishedAt: IsoDateTimeSchema.nullable(),
  createdAt: IsoDateTimeSchema,
  updatedAt: IsoDateTimeSchema.optional(),
});
export type JobSummary = z.infer<typeof JobSummarySchema>;

/**
 * POST /jobs/:id/retry. `confirmRespend` is the Author's answer to a job parked
 * with jobs.render.outcomeUnresolved or jobs.sample.outcomeUnresolved: the
 * provider may already have charged for the request that died in flight, and
 * this says to send it again anyway. Every other parked job retries without it.
 */
export const JobRetryRequestSchema = z.strictObject({
  confirmRespend: z.boolean().optional(),
});
export type JobRetryRequest = z.infer<typeof JobRetryRequestSchema>;
